import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import DefaultLayout from "../../components/DefaultLayout";
import {List, WhiteSpace} from 'antd-mobile';
import ClaimService from "../../apiServices/ClaimService";
import * as helper from '../../utils/helper';

const Item = List.Item;

class ClaimDetail extends Component {
    constructor(props){
        super(props);

        const urlParams = new URLSearchParams(window.location.search);
        const claim_id = urlParams.get('id');

        this.state = {
            height: props.height,
            hasError: false,
            claim_id: claim_id,
            claim: null,
        };
    }

    componentDidMount() {
        this.setState({height: window.innerHeight + 'px'});
        if(this.state.claim_id){
            ClaimService.detail(this.state.claim_id).then(response => {
                this.setState({claim: response.data});
            }).catch(function(error){
                console.log(error);
            });
        }else{
            console.log('không lấy được thông tin');
        }
    }

    render() {
        let claimInfo;
        if (this.state.claim){
            claimInfo = (<div><List renderHeader={() => 'Thông tin xe'} className="od_header">
                <Item extra={this.state.claim.car_brand.name}>Hãng xe</Item>
                <Item extra={this.state.claim.car_product.name}>Dòng xe</Item>
                <Item extra={this.state.claim.user_car.plate_number}>Biển số xe</Item>
                <Item extra={this.state.claim.insu_brand.name}>Hãng bảo hiểm</Item>
            </List>
            <WhiteSpace size='xl' />
            <List renderHeader={() => 'Thông tin khiếu nại'} className="od_header">
                <Item extra={helper.formatDate2(this.state.claim.created_at)}>Thời gian KN</Item>
                <Item extra={this.state.claim.description}>Mô tả</Item>
                <Item extra={this.state.claim.claim_stat}>Trạng thái</Item>
            </List>
            <WhiteSpace size='xl' />
            <List renderHeader={() => 'Thông tin bồi thường/Sửa chữa'} className="od_header">
                <Item extra='...'>Hạng mục sửa chữa</Item>
                <Item extra='25.000.000đ'>Số tiền bồi thường</Item>
                <Item extra='2 Ngày'>Thời gian sửa</Item>
            </List>
            </div>);
        }

        return (
            <div className='App-block bgWhite' style={{minHeight: this.state.height}}>
                <DefaultLayout {...this.props} title="Yêu cầu bồi thường" backToHome={true} classNameContent="bgWhite" page_type={1} hiddenFt={true} showHome={true}>
                    <div className="wrap-content">
                        {claimInfo}
                        <WhiteSpace size='xl' />
                    </div>
                </DefaultLayout>
            </div>
        )
    }
}

export default (withTranslation())(ClaimDetail);